<app-account-subform-shell
  titleId="account-sms-verify-title"
  [crumb]="'Account settings / Alerts' | translate"
  [title]="'Confirm your mobile number' | translate"
  variant="tall"
  (back)="cancelled.emit()"
>
  @if (locked) {
    <p class="lead">
      {{
        'That code has been locked after too many incorrect attempts. Request a new one, or set this up later from your account settings.'
          | translate
      }}
    </p>
    <div class="note note-info">
      {{ 'Your email alerts are unaffected and are still being delivered.' | translate }}
    </div>
  } @else if (expiresIn === 0) {
    <div class="note note-warn">
      <app-account-icon name="clock" [size]="16"></app-account-icon>
      <span
        ><strong>{{ 'This code has expired.' | translate }}</strong>
        {{ 'Codes last about 5 minutes. We can send a new one to' | translate }}
        <strong>{{ phoneNumber }}</strong>.</span
      >
    </div>
  } @else {
    <p class="lead">
      {{ 'We texted a 6-digit code to' | translate }} <strong>{{ phoneNumber }}</strong>.
    </p>
    <div class="field">
      <span class="label">{{ 'Verification code' | translate }}</span>
      <app-account-otp-input
        [length]="codeLength"
        [invalid]="codeInvalid"
        [label]="'Verification code' | translate"
        (codeChange)="onCodeChange($event)"
        (submitted)="verify()"
      ></app-account-otp-input>
    </div>
    @if (codeInvalid) {
      <div class="note note-error" role="alert">
        <app-account-icon name="alert-circle" [size]="16"></app-account-icon>
        <span
          ><strong>{{ "That code isn't right." | translate }}</strong>
          {{ 'Check the last text you received and try again —' | translate }}
          <strong>{{ '{{count}} attempts left' | translate: { count: attemptsRemaining } }}</strong>.</span
        >
      </div>
    }
    <div class="meta">
      <span class="meta-item"
        ><app-account-icon name="clock" [size]="14"></app-account-icon> {{ 'Expires in' | translate }}
        <strong>{{ expiresInDisplay }}</strong></span
      >
    </div>
  }

  <div class="meta">
    @if (!locked && resendCooldown > 0) {
      <span class="meta-item"
        ><app-account-icon name="refresh" [size]="14"></app-account-icon> {{ 'Resend in' | translate }}
        <strong>{{ resendCountdownDisplay }}</strong></span
      >
    } @else {
      <button type="button" class="link-btn resend" [disabled]="sending" (click)="resend()">
        <app-account-icon name="refresh" [size]="14"></app-account-icon> {{ 'Send a new code' | translate }}
      </button>
    }
    <span class="sep" aria-hidden="true">|</span>
    <button type="button" class="link-btn wrong-number" (click)="changeNumber.emit()">
      {{ 'Wrong number?' | translate }}
    </button>
  </div>

  <div subformFooter class="footer-actions">
    <button type="button" class="as-btn-secondary" (click)="cancelled.emit()">
      {{ 'Cancel' | translate }}
    </button>
    <button type="button" class="as-btn-primary verify" [disabled]="!canVerify" (click)="verify()">
      {{ 'Confirm' | translate }}
    </button>
  </div>
</app-account-subform-shell>
